module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Networks",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M47.25,25.4565833 C44.8622418,25.4565833 24.3680346,25.4565833 22.75,25.4565833 C22.75,19.7729785 24.7964569,14.913664 29.6914418,12.9505373 C29.1767639,12.3640935 27.6576762,10.5813247 27.6576762,7.64836913 C27.6576762,4.23312005 30.3948391,6.72043399e-15 35,0 C39.2843371,-6.25224733e-15 42.3176005,3.74411483 42.3176005,7.64836913 C42.3176005,11.1873894 40.3295179,12.7282916 40.3295179,12.9599019 C45.2084568,14.9290834 47.25,19.7819948 47.25,25.4565833 Z M24.5,60 C22.1122418,60 1.61803455,60 0,60 C0,54.3163952 2.0464569,49.4570807 6.94144178,47.493954 C6.42676392,46.9075102 4.90767619,45.1247414 4.90767619,42.1917858 C4.90767619,38.7765368 7.6448391,34.5434167 12.25,34.5434167 C16.5343371,34.5434167 19.5676005,38.2875315 19.5676005,42.1917858 C19.5676005,45.7308061 17.5795179,47.2717084 17.5795179,47.5033186 C22.4584568,49.4725001 24.5,54.3254115 24.5,60 Z M70,60 C67.6122418,60 47.1180346,60 45.5,60 C45.5,54.3163952 47.5464569,49.4570807 52.4414418,47.493954 C51.9267639,46.9075102 50.4076762,45.1247414 50.4076762,42.1917858 C50.4076762,38.7765368 53.1448391,34.5434167 57.75,34.5434167 C62.0343371,34.5434167 65.0676005,38.2875315 65.0676005,42.1917858 C65.0676005,45.7308061 63.0795179,47.2717084 63.0795179,47.5033186 C67.9584568,49.4725001 70,54.3254115 70,60 Z M10.5,7.27229825 L15.75,7.27756916 L15.75,9.09564372 L12.2739258,9.09037282 L12.2739258,12.7335128 L10.5,12.7335128 L10.5,7.27229825 Z M59.5,7.27229825 L59.5,12.7335128 L57.7260742,12.7335128 L57.7260742,9.09037282 L54.25,9.09037282 L54.25,7.27229825 L59.5,7.27229825 Z M19.25,7.27229825 L24.5,7.27229825 L24.5,9.09037282 L19.25,9.09037282 L19.25,7.27229825 Z M10.5,16.3626711 L12.25,16.3626711 L12.25,21.8168948 L10.5,21.8168948 L10.5,16.3626711 Z M10.5,25.4530439 L12.25,25.4530439 L12.25,30.9072676 L10.5,30.9072676 L10.5,25.4530439 Z M59.5,25.4530439 L59.5,30.9072676 L57.75,30.9072676 L57.75,25.4530439 L59.5,25.4530439 Z M57.75,16.3626711 L59.5,16.3626711 L59.5,21.8168948 L57.75,21.8168948 L57.75,16.3626711 Z M36.75,58.178386 L42,58.178386 L42,59.9964606 L36.75,59.9964606 L36.75,58.178386 Z M28,58.178386 L33.25,58.178386 L33.25,59.9964606 L28,59.9964606 L28,58.178386 Z M45.5,7.27229825 L50.75,7.27229825 L50.75,9.09037282 L45.5,9.09037282 L45.5,7.27229825 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee365170"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/networks.vue
// module id = 672
// module chunks = 1